import './inputRooms.js'
import './yoastFAQs.js'
import './guidedSellingWidget.js'
import './langSwitcher.js'
import './carousel.js'
import './autoRotateTabs.js'
import '../util/pageLang.js'
import './gravity-forms/forms.js'


export default {
  init() {
    // JavaScript to be fired on all pages
    $(function () {
      // Header navbar menu
      $('.header.navbar li.menu-item-has-children a:first-child:nth-last-child(2)').addClass('dropdown-toggle').attr({
        id: 'navbarDropdown',
        role: 'button',
        'aria-haspopup': 'true',
        'aria-expanded': 'false',
      }).append('<svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-chevron-down d-none d-lg-inline ml-2" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/></svg>');

      var newElem = $('<ul class="language-switcher border-0 mb-0 mt-3"></ul>');

      var responsiveNavDropdown = function () {
        // Mobile
        if ($(window).width() < 992) {

          // New element subtoggle (down arrow)
          $('<button class="header-subtoggle d-block d-lg-none position-absolute" aria-label="Open this menu tiem"><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-chevron-down" fill="#141414" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/></svg></button>').insertAfter('.header.navbar li.menu-item-has-children a:not(.d-none):first-child:nth-last-child(2)');

          // Append language switcher
          newElem.appendTo($('.navbar-collapse .mobile-nav-footer'));
          $('.header.navbar .language-switcher .dropdown').appendTo($('.mobile-nav-footer .language-switcher'))

          // Close navbar dropdowns on outsite click.
          $(document).on('click', function (e) {
            let menu = $('.header.navbar .menu-item-has-children.dropdown');
            if (!$(e.target).is(menu) && menu.hasClass('show')) {
              menu.removeClass('show');
              menu.children('.sub-menu').removeClass('show');
              menu.children('.dropdown-toggle').attr('aria-expanded', 'false');
            }
          });

          // Dropdown on down arrow clicked
          $('.header.navbar .menu-item-has-children.dropdown .header-subtoggle').on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();

            // Close other dropdowns except current one.
            if ($(this).parent().siblings().hasClass('show')) {
              $(this).parent().siblings().removeClass('show');
              $(this).parent().siblings().children('.sub-menu').removeClass('show');
              $(this).parent().siblings().children('.dropdown-toggle').attr('aria-expanded', 'false');
            }

            // Close dropdowns on second click (toggle dropdowns)
            $(this).parent().toggleClass('show');
            $(this).siblings('.sub-menu').toggleClass('show');
            if ($(this).siblings('.dropdown-toggle').attr('aria-expanded') === 'false') {
              $(this).siblings('.dropdown-toggle').attr('aria-expanded', 'true');
            } else {
              $(this).siblings('.dropdown-toggle').attr('aria-expanded', 'false');
            }
          });

          // Menu links
          $('.header.navbar .menu-item-has-children.dropdown:not(.dropdown-langs) a').on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = $(this).attr('href');
          })

          // Disable scroll on mobile if the mega menu is open.
          $('.navbar-toggler').on('click', function () {
            setTimeout(function() {
              if ($('.navbar-collapse').hasClass('show')) {
                $('body').addClass('no-scroll'); // Stop background page scroll
              } else {
                $('body').removeClass('no-scroll');
              }
            }, 500);
          });

          // Close dropdowns when language switcher clicked.
          let langSwitcher = $('.navbar-collapse .language-switcher .dropdown');
          let langSwitcherButton = $('.navbar-collapse .language-switcher .dropdown .header-subtoggle');

          // Close language switcher when other dropdown clicked.
          $('.header.navbar .menu-item-has-children.dropdown:not(.dropdown-langs) .header-subtoggle').on('click', function() {
            if (langSwitcher.hasClass('show')) {
              langSwitcher.removeClass('show');
              langSwitcher.children('.sub-menu').removeClass('show');
              langSwitcher.children('.dropdown-toggle').attr('aria-expanded', 'false');
            }
          });
        
          (langSwitcher, langSwitcherButton).on('click', function() {
            $('.header.navbar .menu-item-has-children.dropdown:not(.dropdown-langs)').removeClass('show');
            $('.header.navbar .menu-item-has-children.dropdown:not(.dropdown-langs)').children('.sub-menu').removeClass('show');
            $('.header.navbar .menu-item-has-children.dropdown:not(.dropdown-langs)').children('.dropdown-toggle').attr('aria-expanded', 'false');
          });

          // Keep menu open if menu-list--title clicked.
          $('.header.navbar .menu-item-has-children li.menu-list--title').on('click', function(e) {
            e.stopPropagation();
          });
        } else {
          // Enable top nav link
          $('.header.navbar li.menu-item-has-children a:first-child:nth-last-child(2)').removeClass('disabled');

          // Dropdown on hover
          $('.header.navbar .menu-item-has-children.dropdown, .language-switcher .dropdown').mouseover(function () {
            $(this).addClass('show');
            $(this).children('.sub-menu').addClass('show');
            $(this).children('.dropdown-toggle').attr('aria-expanded', 'true');
          }).mouseout (function () {
            $(this).removeClass('show');
            $(this).children('.sub-menu').removeClass('show');
            $(this).children('.dropdown-toggle').attr('aria-expanded', 'false');
          });
        }
      }
      $(window).on('load resize', responsiveNavDropdown);

      $('.header.navbar .menu-item-has-children.dropdown:not(.dropdown-langs)').mouseover(function () {
        if ($('.header.bg-clear')) {
          $('.header.bg-clear').addClass('bg-clear-hover');
        }
      }).mouseout (function () {
        if ($(this).closest('.header.navbar').hasClass('bg-clear-hover')) {
          $('.header.bg-clear-hover').removeClass('bg-clear-hover');
        }
      });

      $('.header.navbar .nav > li.menu-item-has-children > .sub-menu').addClass('row justify-content-center dropdown-menu border-0').attr('aria-labelledby', 'navbarDropdown');
      $('.header.navbar .menu-list--right ul, .header.navbar .menu-list--left ul').removeClass('sub-menu').addClass('row  pl-0');
      $('.header.navbar .menu-list:not(.menu-list--features) .menu-list--left a:first-child:nth-last-child(2), .header.navbar .menu-list--right a:first-child:nth-last-child(2)').addClass('d-none');
      $('.header.navbar .menu-list--features .menu-list--left').children('a').addClass('d-none');

      var checkScroll = function () {
        $('.header.bg-clear').toggleClass('scrolled', $(this).scrollTop() > 60);
      }
      $(window).on('load resize scroll', checkScroll);

      // Add language switcher within main nav-right menu container
      var source = $('.collapse.navbar-collapse .language-switcher');
      var destination = $('.menu-primary-navigation-right-container .nav.nav-right');
      $(source).prependTo(destination);

      // Footer navbar menu
      $('.footer li.menu-item-has-children a:first-child:nth-last-child(2)').attr({
        id: 'navbarDropdown',
        role: 'button',
        'aria-haspopup': 'true',
        'aria-expanded': 'false',
      });

      $('footer li.menu-item-has-children').append('<svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-chevron-down ml-2 d-block d-lg-none" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/></svg>');
      $('.footer .bi-chevron-down').click(
        function () {
          $(this).closest('li').toggleClass('active');
          if (jQuery('.footer li.menu-item-has-children').hasClass('active')) {
            $('.active .sub-menu').slideDown();
            $('.active .sub-menu').addClass('menu-open');
          } else {
            $('.sub-menu').slideUp();
            $('.sub-menu').removeClass('menu-open');
          }
          $(this).children('.dropdown-toggle').attr('aria-expanded', 'true');
        });
      $('.footer .nav > li.menu-item-has-children > .sub-menu').addClass('justify-content-center navbar-menu border-0').attr('aria-labelledby', 'navbarDropdown');

      $('[data-toggle="tooltip"]').tooltip();

        // Basic bootstrap form
        $('.basic-form .form-control').focusin( function () {
            $(this).closest('.form-group').addClass('in-focus');
        });

        $('.basic-form .form-control').focusout( function () {
          $(this).closest('.form-group').removeClass('in-focus');
      });

      document.querySelectorAll('li.nav-subheading a, li.shortcode a').forEach(anchor => {
        const parent = anchor.parentNode;
        while (anchor.firstChild) {
              parent.insertBefore(anchor.firstChild, anchor);
          }
          anchor.remove();
      });

      document.querySelectorAll('.shortcode svg.bi-chevron-down').forEach(svg => {
        svg.remove(); // Remove each SVG found
      });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js